module.exports = __webpack_public_path__ + "static/media/reedemer.b5c12497.png";